/* istanbul ignore file */
/* eslint-disable @typescript-eslint/naming-convention, comma-dangle */
export type IThemeLoader = () => Promise<unknown>;

export const getGlobalTheme = (): Promise<void> => (
  import(
    /* webpackChunkName: 'default' */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    '../css/main.css'
  )
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getThemesMapping = (): { [brand: string]: IThemeLoader } => (
  {
    fredericmalle: (): Promise<void> => import(
      /* webpackChunkName: 'fredericmalle' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/fredericmalle.css'
    ),
    glamglow: (): Promise<void> => import(
      /* webpackChunkName: 'glamglow' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/glamglow.css'
    ),
  }
);

export const getRegionThemesMapping = (): { [brand: string]: IThemeLoader } => (
  {
    aveda_jp: (): Promise<void> => import(
      /* webpackChunkName: 'aveda_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/aveda_jp.css'
    ),
    aveda_tr: (): Promise<void> => import(
      /* webpackChunkName: 'aveda_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/aveda_tr.css'
    ),
    bobbibrown_au: (): Promise<void> => import(
      /* webpackChunkName: 'bobbibrown_au' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/bobbibrown_au.css'
    ),
    bobbibrown_jp: (): Promise<void> => import(
      /* webpackChunkName: 'bobbibrown_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/bobbibrown_jp.css'
    ),
    bobbibrown_tr: (): Promise<void> => import(
      /* webpackChunkName: 'bobbibrown_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/bobbibrown_tr.css'
    ),
    clinique_au: (): Promise<void> => import(
      /* webpackChunkName: 'clinique_au' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/clinique_au.css'
    ),
    clinique_jp: (): Promise<void> => import(
      /* webpackChunkName: 'clinique_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/clinique_jp.css'
    ),
    clinique_tr: (): Promise<void> => import(
      /* webpackChunkName: 'clinique_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/clinique_tr.css'
    ),  
    cremedelamer_jp: (): Promise<void> => import(
      /* webpackChunkName: 'cremedelamer_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/cremedelamer_jp.css'
    ),
    darphin_gb: (): Promise<void> => import(
      /* webpackChunkName: 'darphin_gb' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/darphin_gb.css'
    ),
    darphin_tr: (): Promise<void> => import(
      /* webpackChunkName: 'darphin_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/darphin_tr.css'
    ),
    esteelauder_au: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_au' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_au.css'
    ),
    esteelauder_cl: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_cl' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_cl.css'
    ),
    esteelauder_jp: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_jp.css'
    ),
    esteelauder_mx: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_mx' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_mx.css'
    ),
    esteelauder_tr: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_tr.css'
    ),
    esteelauder_vn: (): Promise<void> => import(
      /* webpackChunkName: 'esteelauder_vn' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/esteelauder_vn.css'
    ),
    jomalone_au: (): Promise<void> => import(
      /* webpackChunkName: 'jomalone_au' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/jomalone_au.css'
    ),
    jomalone_jp: (): Promise<void> => import(
      /* webpackChunkName: 'jomalone_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/jomalone_jp.css'
    ),
    jomalone_my: (): Promise<void> => import(
      /* webpackChunkName: 'jomalone_my' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/jomalone_my.css'
    ),
    jomalone_tr: (): Promise<void> => import(
      /* webpackChunkName: 'jomalone_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/jomalone_tr.css'
    ),
    jomalone_vn: (): Promise<void> => import(
      /* webpackChunkName: 'jomalone_vn' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/jomalone_vn.css'
    ),
    labseries_jp: (): Promise<void> => import(
      /* webpackChunkName: 'labseries_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/labseries_jp.css'
    ),
    maccosmetics_au: (): Promise<void> => import(
      /* webpackChunkName: 'maccosmetics_au' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/maccosmetics_au.css'
    ),
    maccosmetics_jp: (): Promise<void> => import(
      /* webpackChunkName: 'maccosmetics_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/maccosmetics_jp.css'
    ),
    maccosmetics_tr: (): Promise<void> => import(
      /* webpackChunkName: 'maccosmetics_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/maccosmetics_tr.css'
    ),
    origins_tr: (): Promise<void> => import(
      /* webpackChunkName: 'origins_tr' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/origins_tr.css'
    ),
    toofaced_jp: (): Promise<void> => import(
      /* webpackChunkName: 'toofaced_jp' */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '../css/toofaced_jp.css'
    ),
  }
);
